<template>
  <el-dialog append-to-body :before-close="close" :visible.sync="visible" width="860" title="饮食解读">
      <Form :label-width="120" label-colon>
        <FormItem class="early-warn-text" label="图片">
          <img v-for="img in imgs" :key="img" class="topImg" :src="img" />
        </FormItem>
        <FormItem label="报告时间"> {{ formatTime }}</FormItem>
        <FormItem label="饮食反馈">
          <Input v-if="!readOnly" v-model="suggestion" type="textarea" :rows="4" placeholder="" autofocus :disabled="Boolean(status === 2||status === 3)" />
          <div v-else>
              {{suggestion}}
          </div>
        </FormItem>
        <div v-if="!readOnly" class="lu-footer">
          <Button class="send-btn" @click="close">关闭</Button>
          <Button v-if="status === 1" type="primary" class="send-btn" @click="submit">处理</Button>
        </div>
        <div v-else class="lu-footer">
          <Button class="send-btn" @click="close">关闭</Button>
        </div>
      </Form>
    </el-dialog>
</template>

<script>
import dayjs from "dayjs";
import { parseDietImages, resolveMediaUrl } from "@/utils/dietImages";
export default {
  name: "",
  props:['visible','row'],
  data() {
    return {
      suggestion: "",
      status: 0,
      readOnly:true,
      time: new Date().getTime(),
      imgs: [],
    };
  },
  created() {
    var that=this;
    that.$watch('visible', function() {
      if(that.visible)
      {
        that.loadData();
      }
      else{
        that.suggestion='';
        that.status=0;
        that.imgs=[];
      }
    });
  },
  computed: {
    formatTime: function () {
      const t = this.time;
      if (t === undefined || t === null || t === "") {
        return "";
      }
      const d = dayjs(t);
      return d.isValid() ? d.format("YYYY-MM-DD HH:mm:ss") : "";
    },
  },
  methods: {
    close(){
      this.$emit("close");
    },
    loadData() {
      const vm = this;
      var suggestId=vm.row.id;
      if(suggestId){
        vm.api.dietaryInfo({ id: suggestId }).then((res) => {
        const body = res.data || {};
        const diet = body.diet;
        if (!diet) {
          return;
        }
        const { img, status, message: suggestion, createTime: time } = diet;
        vm.imgs = parseDietImages(img).map(resolveMediaUrl);
        vm.suggestion = suggestion || "";
        vm.status = status;
        vm.time = time != null ? time : new Date().getTime();
      });
      }
      
    },
    submit() {
      const vm = this;
      const { suggestion, row, page } = vm;
      vm.api.dietaryUpdate({id: row.id,message: suggestion}).then(function () {
          vm.close();
          vm.fetchData({ page });
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  },
};
</script>
<style lang="less" scoped="scoped">
.process
{
  
}

</style>
